<template>
  <div class="pic_area">
 <!--   <div class="pic_area_select">
    globe
  </div> -->
  <div class="pic_area_input">
    <input @input="theInput" type="number" placeholder="不用加63 直接输入09或9开头号码" v-model="inputNumber" maxlength="11"  autofocus="autofocus" >
  </div>
  <br>
 <!-- <div>
  <el-input
  type="number"
  size="large"
  placeholder="请输入内容"
  suffix-icon="el-icon-date"
  v-model="inputNumber2">
</el-input> -->

</div>

</div>



</template>

<script>







const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()



export default{
  name:"inputArea",
  data(){
    return {
      inputNumber:"",
      inputNumber2:"",
      theCheck:'',
      theType:'',


    }
  },
  mounted() {
    var _vm = this;
    var usinfo = sessionStorage.getItem(name + 'usinfo');
    if(usinfo){
        var u = JSON.parse(usinfo);
        if(u.Commonnumber){
          _vm.inputNumber = u.Commonnumber;
          _vm.theInput();
        }
    }
  },
   methods:{
    theInput:function(e){

      this.$emit("func","NAN","NAN",true);
      this.inputNumber=this.inputNumber.replace(/^\.+|[^\d.]/g,'').slice(0,11);

      var Num=this.inputNumber;


      if(Num.length==4){


        var check= this.common.test(Num);
        switch(check){
          case 1:
          this.theType=1;

          break;
          case 2:
          this.theType=2;

          break;
          case 3:
          this.theType=3;

          break;
             case 4:
          this.theType=4;

          break;

        }
        this.$emit("func",this.inputNumber,this.theType,false)

      }
      if (Num.length>4) {
        delay(() => {
          var check= this.common.test(Num);
          //console.log(Num.length,check)
          switch(check){
            case 1:
            this.theType=1;

            break;
            case 2:
            this.theType=2;

            break;
            case 3:
            this.theType=3;

            break;
              case 4:
            this.theType=4;

            break;

          }

          this.$emit("func",this.inputNumber,this.theType,false)

        },500)

      }



    }


  }

  ,

created:function(){
      // 在挂载的时候将验证函数绑定（多用于CLICK事件）
      // this.debounceTest=this.common.debounce(this.common.test(),500)







    },

  }

  </script>
  <style scoped>
  input::-webkit-input-placeholder{
          font-size:12px;
          color:#878787;
        }

  .pic_area{
    height: 2.5rem;
    line-height: 2.5rem;

    /* border-radius:20px; */
    border-bottom: 1px solid #959595;
    display: flex;
    position: relative;

  }
  .pic_area::before{
    content: "";
    position: absolute;
    top:-10px;
    left:-35px;
    width: 44px;
    height:44px;
    background-image: url(../../static/images/logo.png);
    background-size: 100% 100%;
    background-position: center;
  }

  .pic_area_input{
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    align-items: center;

  }
  .pic_area_input input{
    width: 100%;
  }
  input{
    border: 0;
    padding: 0;
    outline: none;
    height: 30px;
    font-size: 1em;
    margin:  0  10px;
    text-align: center;
  }
  input::-webkit-input-placeholder{
    text-align: center;
    font-size:1em;

  }

  </style>



// WEBPACK FOOTER //
// src/components/inputArea.vue